import { makeStyles } from '@material-ui/core/styles';

// MUIDialog
const useStyles = makeStyles((theme) => ({
    root: {

    },
    scrollPaper: {
        height: 'auto',
    },
    paper: {
        maxHeight: '80vh',
        padding: '0 0 10px 0',
    },
}));

export default useStyles;
